import React, { useState } from 'react'
import { Box, Loader } from '@usap/uicomponents'
import styled from 'styled-components'

import ListView from './ListView'
import GridView from './GridView'

const Container = styled(Box)`
  padding: ${props => props.theme.global.edgeSize.small};
`

const Categories = styled(Box)`
  margin: 0px auto;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    margin: ${props => props.theme.global.edgeSize.medium} auto;
  }
`

export default function TopCategories({
  categoryPart,
  selVName,
  Link,
  handleCategoryPartsonClick,
  loading,
  partList,
}) {
  const [isListView, toggleListView] = useState(false)

  return (
    <Container background="light-1">
      {loading && <Loader />}
      <Categories
        id="categories"
        width="1248px"
      >
        <GridView
          categoryPart={categoryPart}
          isListView={isListView}
          toggleListView={toggleListView}
          Link={Link}
          selVName={selVName}
        />
        <ListView
          isListView={isListView}
          toggleListView={toggleListView}
          selVName={selVName}
          categoryPart={categoryPart}
          partList={partList}
          Link={Link}
          handleCategoryPartsonClick={handleCategoryPartsonClick}
        />
      </Categories>
    </Container>
  )
}
